angular.module('userService', [])
.factory('UserService', ["$window", "$http", function ($window, $http) {
    var service = {},
        user = $window._user;

    service.getModel = function() {
      return user;
    };

    service.isAuthenticated = function () {
      return user.isAuthenticated;
    };

    service.saveModel = function(obj) {
      user = angular.extend({}, user, obj);
    };

    service.sendSecret = function() {
      return $http({
        url: user.api.secret,
        headers: {
          'Accept': '*/*',
          'X-Requested-With': 'XMLHttpRequest'
        },
        method: 'GET',
        dataType: 'json'
      });
    };

    return service;
  }]);



//////////////////
// WEBPACK FOOTER
// ../components/cian/src/scripts/user_service.js
// module id = 79
// module chunks = 0